import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';
import Dialog from './../../components/Dialog/Dialog';

import RequestListItem from './../../components/Request/RequestListItem'
import Header from './../../components/Header';
import SuperAdminHeader from './../../components/Header/SuperAdmin';
import Subheader from './../../components/Subheader';
import Footer from './../../components/Footer';

class SuperAdminMessagesPage extends PureComponent {

    constructor(props) {
        super(props);
        autobind(this);

        this.getMessages();
        this.getReports();

        this.state = {
            currentView: 'messages',
            toDeleteMessagesId: [],
            confirmDeleteModalOpen: false
        }
    }

    componentDidMount() {
        this.getMessages();
    }

    getMessages() {
        this.props.getMessages();
    }

    getReports() {
        this.props.getReports();
    }

    getSuperAdminReports() {
        this.props.getSuperAdminReports();
    }

    readMessages(myUnreadMessages) {
        const myUnreadMessagesParanoidMode = myUnreadMessages.filter(m => m.to.id === this.props.user._id && !m.read)
        if(myUnreadMessagesParanoidMode.length)
            this.props.readMessages(myUnreadMessagesParanoidMode.map(m => m.id))
    }

    onSendButtonClick(toId, identifier, messageTypeId, message) {
        this.props.addMessage(this.props.user._id, toId, identifier, message, () => {
            this.getMessages();
        });
    }

    onRequestDelete(messages) {
        this.props.deleteMessages(messages.map(message => message.id), () => {
            this.getMessages()
            this.getReports();
        })
    }

    confirmDeleteModalProceed() {
        const { toDeleteMessagesId } = this.state

        if (toDeleteMessagesId.length) {
            this.props.deleteMessages(toDeleteMessagesId, () => {
                this.confirmDeleteModalHide()
                this.getMessages()
                this.getReports();
            })
        }

    }

    confirmDeleteModalShow(messages) {
        this.setState({
            toDeleteMessagesId: messages.map(message => message.id),
            confirmDeleteModalOpen: true
        })
    }

    confirmDeleteModalHide() {
        this.setState({
            confirmDeleteModalOpen: false
        })
    }

    changeView(e, nextView) {
        e.preventDefault();

        const { currentView } = this.state
        if (currentView !== nextView) {

            switch (nextView) {
                case 'messages':
                    this.getMessages();
                    break;
                case 'reports':
                    this.getReports();
                    break;
                case 'allReports':
                    this.getSuperAdminReports();
                    break;
                default: break;
            }

            this.setState({
                currentView: nextView
            })
        }

    }

    getView(items) {

        const { messages, reports, allReports } = items;

        switch (this.state.currentView) {
            case 'messages':
                return (<div>
                    <div className="items-list-filters">
                        <h4 className="mb-0">Campaign Messages ({messages.length})</h4>
                    </div>
                    <div className="items-list items-list--requests">
                        <div className="items-labels">
                            <div className="items-label-index">#</div>
                            <div className="items-label-1">Message type</div>
                            <div className="items-label-2">Product / Notification</div>
                            <div className="items-label-3">User</div>
                            <div className="items-label-4">Date</div>
                            <div className="items-label-5">Actions</div>
                        </div>
                        {messages.length ? messages : <p>You have no messages.</p>}
                    </div>
                </div>)
            case 'reports':
                return (<div>
                    <div className="items-list-filters">
                        <h4 className="mb-0">Campaign problem reports ({reports.length})</h4>
                    </div>
                    <div className="items-list items-list--requests">
                        <div className="items-labels">
                            <div className="items-label-index">#</div>
                            <div className="items-label-1">Message type</div>
                            <div className="items-label-2">Product / Notification</div>
                            <div className="items-label-3">User</div>
                            <div className="items-label-4">Date</div>
                            <div className="items-label-5">Actions</div>
                        </div>
                        {reports.length ? reports : <p>You have no reports.</p>}
                    </div>
                </div>)
            case 'allReports':
                return (<div className="items-list items-list--superadmin-reports">
                    <div>
                        <div className="items-list-filters">
                            <h4 className="mb-0">Merchants problem reports ({allReports.length})</h4>
                        </div>
                        <div className="items-list">
                            <div className="items-labels">
                                <div className="items-label-index">#</div>
                                <div className="items-label-1">Message type</div>
                                <div className="items-label-2">Product / Notification</div>
                                <div className="items-label-3">User</div>
                                <div className="items-label-4">Date</div>
                            </div>
                            {allReports.length ? allReports : <p>There are no reports.</p>}
                        </div>
                    </div>
                </div>)
            default: return null
        }
    }

    render() {

        const { messages, reports, allReports } = this.props;

        let threads = [];

        if (messages.length) {

            threads = messages.map((message, index) => {
                return <RequestListItem
                    index={messages.length - index}
                    key={'request_' + index}
                    onSendButtonClick={this.onSendButtonClick}
                    onRequestDelete={this.confirmDeleteModalShow}
                    message={message}
                    messages={message.messages}
                    // messageTitle={message.messages.find(m => m.title).title}
                    // latestMessage={striptags(message.messages[0].message)}
                    readMessages={this.readMessages}
                    product={message.product}
                    notification={message.notification}
                    conversationPartner={message.conversationPartner}
                    userImagePath={message.conversationPartner.picturePath}
                    // latestMessageDate={message.messages[0].createdAt}
                    reply={true}
                    user={this.props.user}
                />;
            });
            threads.reverse();
        }

        let reportThreads = [];

        if (reports.length) {

            reportThreads = reports.map((report, index) => {
                return <RequestListItem
                    index={reports.length - index}
                    key={'request_' + index}
                    onSendButtonClick={this.onSendButtonClick}
                    onRequestDelete={this.confirmDeleteModalShow}
                    message={report}
                    messages={report.messages}
                    // messageTitle={report.messages.find(m => m.title).title}
                    // latestMessage={striptags(report.messages[0].message)}
                    readMessages={this.readMessages}
                    product={report.product}
                    notification={report.notification}
                    conversationPartner={report.conversationPartner}
                    userImagePath={report.conversationPartner.picturePath}
                    // latestMessageDate={report.messages[0].createdAt}
                    reply={false}
                    user={this.props.user}
                />;
            })
            reportThreads.reverse()

        }

        let allReportThreads = [];

        if (allReports.length) {

            allReportThreads = allReports.map((report, index) => {
                return <RequestListItem
                    index={allReports.length - index}
                    key={'request_' + index}
                    onSendButtonClick={this.onSendButtonClick}
                    message={report}
                    messages={report.messages}
                    // messageTitle={report.messages.find(m => m.title).title}
                    // latestMessage={striptags(report.messages[0].message)}
                    readMessages={() => {/* do nothing - admin is only looking at them...*/}}
                    product={report.product}
                    notification={report.notification}
                    conversationPartner={report.conversationPartner}
                    userImagePath={report.conversationPartner.picturePath}
                    // latestMessageDate={report.messages[0].createdAt}
                    reply={false}
                    user={this.props.user}
                />;
            })
            allReportThreads.reverse()
        }

        return (
            <div className={`${this.props.user.role === 3 ? "superadmin" : ""}`}>
                {this.props.user.role === 3 ? <SuperAdminHeader /> : <Header />}
                <Subheader search={false} breadcrumbs={["Messages & Problem Reports"]} />
                <div className="container mt-5">
                    <ul role="tablist" className="nav nav-tabs nav-tabs-primary">
                        <li className="nav-item">
                            <a href="#home" data-toggle="tab" role="tab" className={'messages' === this.state.currentView ? 'nav-link active' : 'nav-link'} onClick={(e) => { this.changeView(e, 'messages') }}>Messages</a>
                        </li>
                        <li className="nav-item">
                            <a href="#home" data-toggle="tab" role="tab" className={'reports' === this.state.currentView ? 'nav-link active' : 'nav-link'} onClick={(e) => { this.changeView(e, 'reports') }}>Problem Reports</a>
                        </li>
                        <li className="nav-item">
                            <a href="#home" data-toggle="tab" role="tab" className={'allReports' === this.state.currentView ? 'nav-link active' : 'nav-link'} onClick={(e) => { this.changeView(e, 'allReports') }}>All Merchants' Problem Reports</a>
                        </li>
                    </ul>
                    {this.getView({
                        messages: threads,
                        reports: reportThreads,
                        allReports: allReportThreads
                    })}
                </div>
                <Dialog open={this.state.confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.confirmDeleteModalHide} message="This item won't be retreivable after deletion." />
                <Footer />
            </div>
        )
    }

}

export default connect(
    (state, ownProps) => {
        const { messages: { requesting, messages, error }, reports: { reports }, superAdminReports: { allReports }, auth: { user } } = state
        return { requesting, messages: messages, allReports, reports, user, error }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps)
    }
)(withRouter(SuperAdminMessagesPage))



// WEBPACK FOOTER //
// ./src/containers/SuperAdmin/SuperAdminReports.js